<template>
  <v-container fluid>
    <v-card class="mx-2">
      <v-card-title>
        <span class="headline">Noticias</span>
      </v-card-title>
      <v-card-text>
        <v-layout class="py-0 px-4 d-flex flex-column">
          <v-row>
            <v-col cols="12" sm="12" md="3" class="text-center">
              <v-btn
                dark
                color="indigo"
                @click="setCreateNewDialog(true)">
                <v-icon left>mdi-plus</v-icon>Publicar
              </v-btn>
            </v-col>
          </v-row>
        </v-layout>
        <v-list-item-group>
          <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
          <v-list v-else>
            <v-list-item v-for="newsItem in this.getListaNews" :key="newsItem._id" class="news-item" two-line @click="editNew(newsItem)">
              <v-list-item-avatar>
                <v-img :src="newsItem.image" :alt="newsItem.title"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ newsItem.title }}</v-list-item-title>
                <v-list-item-subtitle>{{ newsItem.subtitle }}</v-list-item-subtitle>
                <div class="tags">
                  <v-chip v-for="(tag, index) in newsItem.tags" :key="index" color="primary" text-color="white" small>{{ tag }}</v-chip>
                </div>
                <div class="publication-date">{{ newsItem.createdAt | formatDate }}</div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-list-item-group>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations
} from 'vuex';

export default {
  data () {
    return {
      loading: true
    };
  },

  methods: {
    editNew (data) {
      // let editableData = { ...data };
      // editableData.password = '';
      // this.setSelectedNewEdit(editableData);
      // this.setEditAdministradorDialog(true);
    },

    ...mapActions('admin', ['fetchListaNew']),

    ...mapMutations('admin', [
      // 'setSelectedNewEdit',
      // 'setEditAdministradorDialog',
      'setCreateNewDialog'
    ])
  },

  computed: {
    // ...mapGetters('user', ['fetching']),
    ...mapGetters('admin', ['getListaNews'])
  },

  async mounted () {
    await this.fetchListaNew();
    this.loading = false;
  }
};
</script>

<style>
.tags {
  margin-top: 0.5rem;
}
.publication-date {
  margin-top: 1rem;
  font-size: 0.9rem;
  color: #888;
}
</style>
